import {
  Action_GetGroupCate_CusRatePrice,
  Action_GetGroupCate_CusRatePriceSuccess,
  Action_SaveGroupCate_CusRatePrice,
  Action_SaveGroupCate_CusRatePriceSuccess,
  Action_SaveGroupCate_CusRatePriceFailed,
  Action_DeleteGroupCate_CusRatePrice,
  Action_DeleteGroupCate_CusRatePriceSuccess,
  Action_DeleteGroupCate_CusRatePriceFailed,
} from "actions/DanhMuc/GroupCate_CusRatePrice/actionTypes";
import Config from "constants/configs";

const initialState = {
  iSave: Config.sTrangThaiRequestAPI.ChuaGoi,
  iDelete: Config.sTrangThaiRequestAPI.ChuaGoi,
  iSearch: Config.sTrangThaiRequestAPI.ChuaGoi,
  objGroupCate_CusRatePrice: {},
  isProgress: false,
  iState: Config.sTrangThaiRequestAPI.ChuaGoi,
};
////////////////////////
const Reducer_SaveGroupCate_CusRatePrice = (state, action) => ({
  ...state,
  iSave: Config.sTrangThaiRequestAPI.DangGoi,
  isProgress: true,
});
const Reducer_SaveGroupCate_CusRatePriceSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iSave: Config.sTrangThaiRequestAPI.Success,
    isProgress: false,
  };
};
const Reducer_SaveGroupCate_CusRatePriceFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iSave: Config.sTrangThaiRequestAPI.Failed,
    isProgress: false,
  };
};
////////////////////////
const Reducer_DeleteGroupCate_CusRatePrice = (state, action) => ({
  ...state,
  iSave: Config.sTrangThaiRequestAPI.DangGoi,
  isProgress: true,
});
const Reducer_DeleteGroupCate_CusRatePriceSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iSave: Config.sTrangThaiRequestAPI.Success,
    isProgress: false,
  };
};
const Reducer_DeleteGroupCate_CusRatePriceFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    iSave: Config.sTrangThaiRequestAPI.Failed,
    isProgress: false,
  };
};
////////////////////////
const Reducer_GetGroupCate_CusRatePrice = (state, action) => {
  return {
    ...state,
    iSearch: Config.sTrangThaiRequestAPI.DangGoi,
    isProgress: true,
  };
};
const Reducer_GetGroupCate_CusRatePriceSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objGroupCate_CusRatePrice: action.payload,
    iSearch: Config.sTrangThaiRequestAPI.Success,
    isProgress: false,
  };
};

// end
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_SaveGroupCate_CusRatePrice:
      return Reducer_SaveGroupCate_CusRatePrice(state, action);
    case Action_SaveGroupCate_CusRatePriceSuccess:
      return Reducer_SaveGroupCate_CusRatePriceSuccess(state, action);
    case Action_SaveGroupCate_CusRatePriceFailed:
      return Reducer_SaveGroupCate_CusRatePriceFalse(state, action);

    case Action_DeleteGroupCate_CusRatePrice:
      return Reducer_DeleteGroupCate_CusRatePrice(state, action);
    case Action_DeleteGroupCate_CusRatePriceSuccess:
      return Reducer_DeleteGroupCate_CusRatePriceSuccess(state, action);
    case Action_DeleteGroupCate_CusRatePriceFailed:
      return Reducer_DeleteGroupCate_CusRatePriceFalse(state, action);

    case Action_GetGroupCate_CusRatePrice:
      return Reducer_GetGroupCate_CusRatePrice(state, action);
    case Action_GetGroupCate_CusRatePriceSuccess:
      return Reducer_GetGroupCate_CusRatePriceSuccess(state, action);

    default:
      return state;
  }
};
export default authReducer;
